import * as React from "react";
import Swipe from "react-easy-swipe";
import GlobalContext from "../../context/globalContext";
import { getImageUrl } from "../../framework/getImageUrl";

import {
  Dialog,
  withTheme,
  Slide,
  List,
  ListItemText,
  MenuItem,
  ListItemIcon,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from "@material-ui/core";
import {
  Home,
  Close,
  RvHookup,
  AccountBox,
  Feedback,
  CardGiftcard,
  AccessTime,
  VideoLabel,
} from "@material-ui/icons";
import s from "./appBarMenu.module.css";
import { withRouter } from "react-router";
import label from "../../framework/whiteLabel";

function Transition(props) {
  return <Slide direction="right" in={true} {...props} />;
}

const MenuItemPackage = (props) => {
  return (
    <MenuItem
      style={{
        borderBottom: "1px solid lightgray",
        padding: "4px 0",
        margin: "0 20px 8px 20px",
      }}
      onClick={props.onClick}
    >
      <ListItemIcon>{props.iconName}</ListItemIcon>
      <ListItemText style={{ padding: 0 }} primary={props.name} />
    </MenuItem>
  );
};

class FFAppBarMenu extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      left: 0,
      fixed: false,
    };
  }

  // openOrdersDialog = () => {
  //   this.context.global.setGlobalState("ordersDialogState", true);
  //   this.context.global.setGlobalState("appMenuDialogState", false);
  // };

  openAccountDialog = () => {
    // this.context.global.setGlobalState("accountDialogState", true);
    this.context.global.handleDashboardActions("FORWARD", "accountDialogState");
    // this.context.global.setGlobalState("appMenuDialogState", false);
  };

  closeAppMenu = async (item) => {
    if (item) {
      this.context.global.setGlobalState("searchBarTextValue", item);
      this.context.global.getSearchResults(item);
      // this.context.global.setGlobalState("appMenuDialogState", false);
      this.context.global.handleDashboardActions("BACK", "appMenuDialogState");
      window.scrollTo(0, 0);
    } else {
      this.context.global.setGlobalState("searchBarTextValue", "");
      this.context.global.setGlobalState("searchResults", null);
      // this.context.global.setGlobalState("appMenuDialogState", false);
      this.context.global.handleDashboardActions("BACK", "appMenuDialogState");
    }
  };

  render() {
    const { attributes, appMenuDialogState } = this.context.global.data;

    let collections = attributes.filter(
      (item) => item.whiteLabelUuid === label.uuid && item.isCollectionItem
    );

    return (
      <Dialog
        fullScreen
        open={appMenuDialogState}
        onClose={() => this.closeAppMenu()}
        TransitionComponent={Transition}
        scroll={"paper"}
        style={{
          left: this.state.left,
          zIndex: 90002,
        }}
      >
        <AppBar className={s.shoppingCartAppBar}>
          <Toolbar className={s.shoppingCartToolbar}>
            <div className={s.appBarContentContainer}>
              <div className={s.addressContainer}>
                <Typography
                  // className={s.title}
                  variant="body1"
                  color="inherit"
                  noWrap
                >
                  {label.title}
                </Typography>
              </div>
            </div>
            <div className={s.closeButtonContainer}>
              <IconButton
                color="inherit"
                onClick={() => this.closeAppMenu()}
                aria-label="Close"
                className={s.shoppingCartAppBar}
              >
                <Close />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <Swipe
          onSwipeLeft={() => this.closeAppMenu()}
          onSwipeStart={(position) => {
            if (position.y < 10 && position.y > -10) {
              this.setState({ left: 0, fixed: false });
            }
          }}
          onSwipeEnd={(position) => {
            this.setState({ left: 0, fixed: true });
          }}
          onSwipeMove={(position) => {
            if (position.y < 10 && position.y > -10) {
              if (position.x < 0) {
                this.setState({ left: this.state.left - 2 });
              } else {
                this.setState({ left: this.state.left + 2 });
              }
            }
          }}
          tolerance={50}
        >
          <List>
            <div style={{ padding: "20px", color: "grey" }}>
              <div style={{ height: "50px", color: "grey" }} />
              <MenuItemPackage
                name={"Home"}
                iconName={<Home />}
                onClick={() => this.closeAppMenu()}
              />
              <MenuItemPackage
                // name={"Change Location"}
                // iconName={<LocationOn />}
                name={"Change pickup / delivery time"}
                iconName={<AccessTime />}
                onClick={async () => {
                  let redirect = await this.context.global.handleRedirectToFindHotSpot();
                  return this.props.history.replace(redirect);
                }}
              />
              <MenuItemPackage
                name={"Orders"}
                iconName={<RvHookup />}
                onClick={() => this.props.history.push(`/orders`)}
              />
              <MenuItemPackage
                name={"User Account"}
                iconName={<AccountBox />}
                onClick={this.openAccountDialog}
              />
              <MenuItemPackage
                name={"Feedback"}
                iconName={<Feedback />}
                onClick={() => {
                  this.props.history.push("/feedback");
                  // this.closeAppMenu();
                }}
              />
              <MenuItemPackage
                name={"Give a Gift"}
                iconName={<CardGiftcard />}
                onClick={() => {
                  this.props.history.push(`/give`);
                  // document.location.reload();
                }}
              />
              <MenuItemPackage
                name={"Tutorial"}
                iconName={<VideoLabel />}
                onClick={() => {
                  this.context.global.handleOpenTutorial();
                }}
              />
              {}
              {collections.length > 0 ? (
                <p style={{ marginTop: 20 }}>Collections</p>
              ) : null}
              {collections.map((item) => {
                return (
                  <MenuItem
                    key={item.enum}
                    style={{
                      borderBottom: "1px solid lightgray",
                      padding: "4px 0",
                      margin: "0 20px 8px 20px",
                    }}
                    onClick={() => {
                      this.context.global.setGlobalState("searchResults", null);
                      this.context.global.setGlobalState(
                        "searchBarTextValue",
                        item.name
                      );
                      this.closeAppMenu(item.name);
                    }}
                  >
                    <ListItemIcon>
                      <img
                        width={20}
                        height={20}
                        src={getImageUrl(item.imageUrl, "ATTRIBUTE")}
                        alt={item.name}
                      />
                    </ListItemIcon>
                    <ListItemText style={{ padding: 0 }} primary={item.name} />
                  </MenuItem>
                );
              })}
              <p>Categories</p>
              {attributes
                .filter((item) => !item.isCollectionItem)
                .map((item) => {
                  return (
                    <MenuItem
                      key={item.enum}
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "4px 0",
                        margin: "0 20px 8px 20px",
                      }}
                      onClick={() => {
                        this.context.global.setGlobalState(
                          "searchResults",
                          null
                        );
                        this.context.global.setGlobalState(
                          "searchBarTextValue",
                          item.name
                        );
                        this.closeAppMenu(item.name);
                      }}
                    >
                      <ListItemIcon>
                        <img
                          width={20}
                          height={20}
                          src={getImageUrl(item.imageUrl, "ATTRIBUTE")}
                          alt={item.name}
                        />
                      </ListItemIcon>
                      <ListItemText
                        style={{ padding: 0 }}
                        primary={item.name}
                      />
                    </MenuItem>
                  );
                })}
            </div>
          </List>
        </Swipe>
      </Dialog>
    );
  }
}

export default withTheme()(withRouter(FFAppBarMenu));
